export class CommonConstant {
  static ROWS_PER_PAGE_OPTIONS = [5, 10, 15, 25, 30, 40, 50, 100, 200];
  static PRODUCTS_PER_ROW_OPTIONS = [1, 2, 3, 4, 6, 12];
  static DEFAULT_PRODUCT_PAGE_SIZE = 40;
  static DEFAULT_TABLE_PAGE_SIZE = 10;
  static DEFAULT_ORDERS_TABLE_PAGE_SIZE = 10;
}
